import { FC, Fragment } from 'react'
import { CfgQuestionEnum, CfgQuestionValue } from '../app/types/catalog-types'
import styles from './configurator-q-enum.module.css'
import { ThumbnailMenu, ThumbnailMenuItem } from '../controls/thumbnail-menu'
import { useEnvConfig } from '../app/context/environment-context'
import InfoSubtitle from '../controls/infoSubtitle/info-subtitle'
import { Checkbox } from '../controls/checkbox/checkbox'

// this are reused in material component
export const enumYesNoCtrlStyle = styles.enumYesNoCtrl;
export const eyncCtrlStyle = styles.eyncCtrl;
export const eyncTitleStyle = styles.eyncTitle;

export const ConfiguratorEnumQuestion = ({ question, selectedValue, values, onValuesChange } : {
    question: CfgQuestionEnum,
    selectedValue: string | null
    values: CfgQuestionValue[]
    onValuesChange: (values: string[]) => void
}) => {
    if(question.uitype === 'radio') {
        return <ConfiguratorEnumRadio question={question} selectedValue={selectedValue} values={values} onValuesChange={onValuesChange}/>
    } else if(question.uitype === 'checkbox') {
        return <ConfiguratorEnumCheckbox question={question} selectedValue={selectedValue} values={values} onValuesChange={onValuesChange}/>
    } else if(question.uitype === 'thumb') {
        return <ConfiguratorEnumThumb question={question} selectedValue={selectedValue} values={values} onValuesChange={onValuesChange}/>
    } else if(question.uitype === 'thumb+title') {
        return <ConfiguratorEnumThumbTitle question={question} selectedValue={selectedValue} values={values} onValuesChange={onValuesChange}/>
    }
}

export type ConfiguratorEnumProps = {
    question: CfgQuestionEnum,
    selectedValue: string | null
    values: CfgQuestionValue[]
    onValuesChange: (values: string[]) => void
}

export const ConfiguratorEnumRadio: FC<ConfiguratorEnumProps> = ({ question, selectedValue, values, onValuesChange }) => {
    return <form className={styles.enumYesNoCtrl}>
        {values.map((value) => {
            const id = question.id + '-' + value.values[0];
            return <Fragment key={id}>
                <div className={styles.eyncCtrl}>
                    <input disabled={value.disabled ?? false} type="radio" id={id} name={question.id} 
                        checked={value.values[0] === selectedValue}
                        onChange={() => onValuesChange(value.values)}/>
                </div>
                { value.title ? <label className={`${styles.eyncTitle} ${value.disabled ? styles.disabled : ''}`} htmlFor={id}>
                                    {value.title}
                                </label>
                                :
                                null
                }
                { value.description ? <label className={`${styles.eyncDesc} ${value.disabled ? styles.disabled : ''}`} htmlFor={id}>
                                    {value.description}
                                </label>
                                :
                                null
                }

            </Fragment>
        })}
    </form>

}

export const ConfiguratorEnumThumb: FC<ConfiguratorEnumProps> = ({ question, selectedValue, values, onValuesChange }) => {

    const { thumbnailsPath, thumbnailWidth, thumbnailHeight } = useEnvConfig();
    const subTitle = values.filter((value) => value.values[0]===selectedValue)
    
    return (
        <div className={styles.infoContainer}>
            <ThumbnailMenu imgWidth={thumbnailWidth}>
            { 
                values.map(value => {
                    const onClick = () => {
                        if(value.values[0] != selectedValue){
                            onValuesChange(value.values);
                        }
                    }
                    return <ThumbnailMenuItem type="base" key={`${question.id}-${value.values[0]}`}
                                image={`${thumbnailsPath}/${value.thumbnail ?? ''}`} 
                                imgWidth={thumbnailWidth} imgHeight={thumbnailHeight}
                                selected={value.values[0] === selectedValue}
                                onClick={onClick} disabled={value?.disabled}/>
                })
            }
            </ThumbnailMenu>
            {(subTitle.length > 0 && subTitle[0].title) && 
                <div className={styles.infoSubTitleContainer}>
                    <InfoSubtitle text={subTitle[0].title}/>
                </div>
            }
        </div>
    )}

export const ConfiguratorEnumThumbTitle: FC<ConfiguratorEnumProps> = ({ question, selectedValue, values, onValuesChange }) => {

    const { thumbnailsPath, thumbnailWidth, thumbnailHeight } = useEnvConfig();
    const subTitle = values.filter((value) => value.values[0]===selectedValue)
    return (
        <div className={styles.infoContainer}>
            <ThumbnailMenu imgWidth={thumbnailWidth}>
            { 
                values.map(value => {

                    const onClick = () => {
                        if(value.values[0] != selectedValue){
                            onValuesChange(value.values);
                        }
                    }

                    return <ThumbnailMenuItem type="base" key={`${question.id}-${value.values[0]}`}
                                image={`${thumbnailsPath}/${value.thumbnail ?? ''}`}
                                name={value.title ?? ''}
                                imgWidth={thumbnailWidth} imgHeight={thumbnailHeight}
                                selected={value.values[0] === selectedValue}
                                onClick={onClick}/>
                })
            }
            </ThumbnailMenu>
            {(subTitle.length > 0 && subTitle[0].title) && <InfoSubtitle text={subTitle[0].title}/>}
        </div>
    )}

export const ConfiguratorEnumCheckbox: FC<ConfiguratorEnumProps> = ({ question, selectedValue, values, onValuesChange }) => {

    const id = question.id;
    const falseValue = values.find(v => v.order === 0);
    const trueValue = values.find(v => v.order === 1);
    if(!falseValue || !trueValue) {
        throw new Error('Invalid checkbox. Needs a false (order 0) and true (order 1) value');
    }

    const onChange = (v:boolean) => {
        onValuesChange(v ? trueValue.values : falseValue.values);
    }

    return <div className={`${styles.enumYesNoCtrl} ${question.level === 1 ? styles.eyncSub1 : ''}`}>
        <div className={styles.eyncCtrl}>
            <Checkbox id={id} name={question.id}
                    checked={selectedValue === trueValue.values[0]}
                    onChange={e => onChange(e.target.checked)} 
                    disabled = {trueValue?.disabled ?? false}/>
        </div>
        { question.title ? <label className={`${styles.eyncTitle} ${trueValue.disabled ? styles.disabled : ''}`}htmlFor={id}>
                                {question.title}
                            </label>
                        :
                        null
        }
        { question.description ? <label className={`${styles.eyncDesc} ${trueValue.disabled ? styles.disabled : ''}`}htmlFor={id}>
                                    {question.description}
                                 </label>
                                :
                                null
        }               
    </div>

}